import React, { useState, useEffect } from 'react';
import Panel from '../../../components/Panel';
import { Grid, TextField as MUITextField, Button, List, Typography, ListItem, ListItemSecondaryAction, IconButton, makeStyles } from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { TextField } from 'formik-material-ui';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab';
import DeleteIcon from '@material-ui/icons/Delete';
import DataProvider from '../../../providers/DataProvider';
import { useHistory } from 'react-router-dom';
import FormFooter from '../../../components/FormFooter';
import { State } from './AddQuestions';
import { MatchTheTerms, TermsObj } from './EditQuestion';
import { useSnackbar } from 'notistack';

const validation = Yup.object().shape({
    question: Yup.string().required('Required'),
    terms: Yup.array().min(2, "Should add atleast two terms").max(5, "Cant add more then 5 terms").required()
});

const useStyles = makeStyles((theme) => ({
    listText: {
        fontSize: 20
    },
    list: {
        borderRadius: 5,
        borderWidth: 1,
        borderColor: "#878787",
        borderStyle: "solid",
        width: '100%',
        overflow: 'auto',
        height: '180px'
    }
}));

export interface IMatchTheTermsProps {
    data: MatchTheTerms;
    state: State;
}

const EditMatchTheTerms: React.FC<IMatchTheTermsProps> = ({ data, state }) => {

    const classes = useStyles();

    const [term1, setTerm1] = useState("");
    const [term2, setTerm2] = useState("");
    const [terms, setTerms] = useState<TermsObj[]>([]);

    const dataProvider = new DataProvider();
    const [topics, setTopics] = useState<any[]>([]);
    const [subTopics, setSubtopics] = useState<any[]>([]);
    const history = useHistory();
    const matchTerms = data as MatchTheTerms;
    const { enqueueSnackbar } = useSnackbar();

    const handleAddTerm = (callback: any) => {
        if (term1.length > 0 && term2.length > 0) {
            let term: TermsObj = {
                term1: term1,
                term2: term2
            }

            setTerm1("");
            setTerm2("");
            addTerm(term, callback);
        }
    }

    const addTerm = (row: TermsObj, callback: any) => {
        const arr = [...terms];
        arr.push(row);

        callback("terms", arr);
        setTerms(arr);
    }

    const deleteTerm = (index: number, callback: any) => {
        const arr = [...terms];
        arr.splice(index, 1);
        callback("terms", arr);
        setTerms(arr);
    }

    const onTopicSelect = (id: string) => {

        if (id) {
            //@ts-ignore
            dataProvider.getLearningCenterSubTopics(state.company.id, state.department.id, id).then(data => {
                setSubtopics(data);
            });
        }

    }

    useEffect(() => {
        setTerms(data.terms);

        //@ts-ignore
        dataProvider.getLearningCenterTopics(state.company.id, state.department.id).then(data => {
            setTopics(data);
        }).catch(err => {
            console.log(err);
        });

        if (data.subTopic) {

            if (data.subTopic.id !== "") {
                //@ts-ignore
                dataProvider.getLearningCenterSubTopics(state.company.id, state.department.id, data.topic.id).then(data => {
                    setSubtopics(data);
                });
            }

        }
        //mapItems(data);

    }, []);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Formik
                    validationSchema={validation}
                    initialValues={{
                        questionType: matchTerms.questionType,
                        question: matchTerms.questionText,
                        mediaLink: matchTerms.mediaLink,
                        topic: matchTerms.topic,
                        subTopic: matchTerms.subTopic,
                        whereToFind: matchTerms.whereToFind,
                        terms: matchTerms.terms

                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {

                        let termsArr: TermsObj[] = values.terms;

                        let items1: any[] = [];
                        let items2: any[] = [];

                        termsArr.forEach((item, index) => {
                            let obj1 = {
                                name: item.term1,
                                index: index
                            }

                            items1.push(obj1);

                            let obj2 = {
                                name: item.term2,
                                index: index
                            }

                            items2.push(obj2);
                        });

                        let terms = {
                            0: {
                                columnIndex: 0,
                                items: items1
                            },
                            1: {
                                columnIndex: 1,
                                items: items2
                            }
                        }

                        let updateQuestion = {
                            id: matchTerms.tableData.id,
                            questionText: values.question,
                            mediaLink: values.mediaLink,
                            questionType: values.questionType,
                            learningSubTopicId: values.subTopic.id,
                            learningTopicId: values.topic.id,
                            whereToFind: values.whereToFind,
                            terms: terms
                        };

                        //@ts-ignore
                        dataProvider.updateQuestion(state.company.id, state.department.id, state.gameId, state.categoryId, updateQuestion).then(() => {
                            setSubmitting(false);
                            enqueueSnackbar(`Question updated!`, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "bottom" } });
                        }).catch(err => {
                            console.log("Something went wrong:", err);
                            enqueueSnackbar("An error occurred", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "bottom" } });
                            setSubmitting(false);
                        });
                    }}
                >
                    {({ values, submitForm, isSubmitting, setFieldValue, touched, errors }) => (
                        <Grid item container xs={12}>
                            <Form style={{ width: '100%' }}>
                                <Grid container justify="space-between" direction="column" style={{ minHeight: '55vh' }}>
                                    <Grid item container xs={12} spacing={1}>
                                        <Grid item container xs={6} spacing={2}>
                                            <Grid container item spacing={1} xs={12}>
                                                <Grid item xs={5}>
                                                    <MUITextField
                                                        variant="filled"
                                                        label="Term 1"
                                                        value={term1}
                                                        onChange={(event) => {
                                                            setTerm1(event.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <MUITextField
                                                        variant="filled"
                                                        label="Term 2"
                                                        value={term2}
                                                        onChange={(event) => {
                                                            setTerm2(event.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            handleAddTerm(setFieldValue);

                                                        }}
                                                    >Add
                                                </Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container item xs={12} >
                                                <Grid item xs={12}>
                                                    <div>
                                                        <List component="nav" aria-label="main mailbox folders" className={classes.list}>
                                                            {
                                                                terms.map((object, index) => {
                                                                    return (
                                                                        <ListItem button>
                                                                            <Grid item container justify="space-between">
                                                                                <Grid item>
                                                                                    <Typography className={classes.listText}>{object.term1}</Typography>
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <Typography className={classes.listText}>{object.term2}</Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                            <ListItemSecondaryAction>
                                                                                <IconButton edge="end" aria-label="delete" onClick={() => {
                                                                                    deleteTerm(index, setFieldValue);
                                                                                }}>
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </ListItemSecondaryAction>
                                                                        </ListItem>
                                                                    );
                                                                })
                                                            }
                                                        </List>
                                                    </div>
                                                </Grid>
                                                <Grid item style={{ minHeight: 30 }}>
                                                    <Typography color="error">{
                                                        //@ts-ignore
                                                        errors['terms']?.toString()
                                                    }</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={6} spacing={2}>
                                            <Grid item xs={12}>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    label="Question"
                                                    name="question"
                                                    variant="filled"
                                                    fullWidth
                                                    multiline
                                                    rows={3}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormFooter onAction={submitForm} onBack={history.goBack} submitting={isSubmitting} actionName="Save" backActionName="back" />
                                    </Grid>
                                </Grid>
                            </Form>
                        </Grid>
                    )
                    }
                </Formik >
            </Grid>
        </Grid>
    );
}

export default EditMatchTheTerms;